/* * * ./app/Ticket/services/ticket.service.ts * * */
// Imports
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { HttpClient, HttpHeaders, } from '@angular/common/http';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

const access_token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjAzMDgzNTdmMjExMmZjNDM5N2Q1MTYwYmZlMjgzYzkyOWZlYWIyN2JmNjE0MDI5YzdjZmYzZWNkZjk3ZTg5OTJmNTYzNjNlOWQzMGMxY2I5In0.eyJhdWQiOiI0IiwianRpIjoiMDMwODM1N2YyMTEyZmM0Mzk3ZDUxNjBiZmUyODNjOTI5ZmVhYjI3YmY2MTQwMjljN2NmZjNlY2RmOTdlODk5MmY1NjM2M2U5ZDMwYzFjYjkiLCJpYXQiOjE1NjkzMjY5NDIsIm5iZiI6MTU2OTMyNjk0MiwiZXhwIjoxODg0OTQ2MTQyLCJzdWIiOiIiLCJzY29wZXMiOltdfQ.e7OhBg3LHgLRZJBccBu9ZD7H_pcJJT752GC5vcftdEM83blz3lXsJdRrsjQZhwlU1OsFw6swYaVltPRI8RryKriV4ChBXjBU6KdnHZBadcPRsgTO-8LRYNoSR1_Dw73KwIe2VEmFlD_04VqLCuXeNaASfP_q9Lwt9DyhfguG8DgAD2lyP2P9aZc1VVi95PsWeWrj7b33GUezcNh1EvCZ1KgGo6vj9Zczget3ldtMUMbPN9N7sYowMZHAp0pzlh8A881v7k740TsodJ1dlJ8AGxFYMQe87SDBzh32ZtxKgA2iBFen8a6xu-zW6ztWKl4WvUFNJLB28NcyRknHkefiTRjrdwkGBTBA5Shpse4I4GrfAh4_nz7vq6QR9PW_TB7Qil-7gB5aiMzJbMdHT7VI2aCELMAL77gcQx9WsASsHIRbk57aEdKyQonhHtzaz2MUOpLK39YBpXOjbQTdDLLWtaYfJTSuD19S-SyKBBoC53JJqNQ5C9CleFnLBiS82Lme_v9ZfHwYLZnQBBqnL5Volj20qKGFOlHZCv7G-j6i88Pg1hInkhRVGYvtlWQPVPnCzQjzkoF4vtPsuUH23yHEcmQt72uHlDcyAVENRZFwxE6cgvHJbcKHhCvd-J3pqYdik0PfM9BFiKtncSlxfRf2AQUpchEgZeULbL47OLEVK14';

@Injectable()
export class TicketService {

    public ticket_data: {};
    public client: {};
    public success_message: boolean;
    url = 'https://api.parkonomy.com/ticket';

    // Resolve HTTP using the constructor
    constructor (private http: HttpClient) {}

    getClientData() {
        let headers = new HttpHeaders({ 'Authorization' : access_token });
        return this.http.get(this.url + '/' + window.location.host.split('.')[0], { headers: headers })
            .catch(TicketService.handleError);
    }

    searchTicket(ticket_no, vrm) {
        let headers = new HttpHeaders({ 'Authorization' : access_token });
        return this.http.get(this.url + '/' + window.location.host.split('.')[0] + '/' + ticket_no + '/' + vrm, { headers: headers })
            .catch(TicketService.handleError);
    }

    payTicket (ticket_no, vrm, first_name, last_name, card_number, cvc, expiry_date, amount, email) {

        let headers = new HttpHeaders({ 'Authorization' : access_token });
        return this.http.post(this.url + '/pay', {
                ticket_no : ticket_no,
                vrm : vrm,
                firstName : first_name,
                lastName : last_name,
                card_number : card_number,
                cvv : cvc,
                expiry_date,
                amount: amount,
                subdomain: window.location.host.split('.')[0],
                email: email
            }, { headers: headers })
            .catch(TicketService.handleError);
    }

    static handleError (error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Ticket/Services/ticket.service.ts